<template>
  <v-flex v-show="!calendarCollapsed" :md6="!calendarCollapsed" :lg8="!calendarCollapsed" ml-1>
    <!-- <v-slide-x-transition>
      <div class="notes__calendarCollapsed primary" v-show="calendarCollapsed" />
    </v-slide-x-transition> -->
      <v-card>
        <v-container fluid fill-height class="pa-0 ">
          <v-layout row wrap>
            <v-flex style="overflow:hidden;">
              <template v-if="getAllNotes">
                <VueCal
                  style="height:95vh;"
                  :selected-date="today"
                  :time-from="0 * 60"
                  default-view="month"
                  events-on-month-view="short"
                  :no-event-overlaps="false"
                  :todayButton="true"
                  show-all-day-events="'short"
                  :events="filledEvents"
                  locale="ru"
                  events-count-on-year-view
                  :disableViews="['week','day']"
                  @cell-click="selectDateOnCalendar($event)"
                  @view-change="calendarViewChanged($event)"
                  @ready="calendarReady()"
                >
                  <div slot="event-renderer" slot-scope="{ event, view }">
                    <!-- <img src="/static/images/blank-file.svg" class="noteIcon"/> -->
                    <v-icon class="mdi mdi-file-outline noteIcon"/>
                  </div>
                </VueCal>
              </template>
              <loading v-else/>
              
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    
  </v-flex>
</template>
<script>

import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';
import 'vue-cal/dist/i18n/ru.js';

export default {
  name: 'CalendarWrapper',
  data() {
    return {
      calendarSync: true,
      today: moment(new Date()).format('YYYY-MM-DD'),
      datesReady: false,
      allEvents: [],
      param: null,
      calendarCollapsed: false,
      todayBtn: null
    };
  },
  components: {
    VueCal
  },
  methods: {
    selectDateOnCalendar(date) {
      let _today = document.querySelector('.today') // Удаляем подсветку 
      if(_today) {
        _today.classList.remove('selected')
      }
      let _formattedDate = moment(date).format('YYYY-MM-DD')
      this.$bus.$emit('selectDateOnCalendar', _formattedDate)
    },
    calendarViewChanged(date) {
      let _start = moment(date.startDate).format('YYYY-MM-DD')
      let _end = moment(date.endDate).format('YYYY-MM-DD')
      let _out = {
        start: _start,
        end: _end
      }
      store.dispatch('SET_CALENDAR_NOTES', _out)
    },
    calendarReady() { // Нажаи на кнопку сегодня на календаре - подсвечиваем зеленым
      this.todayBtn = document.querySelector('.vuecal__today-btn')
      this.todayBtn.addEventListener('click', this.todayBtnHandler)
    },
    todayBtnHandler() {
      this.selectDateOnCalendar(new Date)
      let _today = document.querySelector('.today')
      _today.classList.add('selected')
    }
  },
  computed: {
    getAllNotes() {
      return store.getters['GET_CALENDAR_NOTES']
    },
    filledEvents() {
      let _out = []
      let _notes = store.getters['GET_CALENDAR_NOTES']
      let _uniqNotes = Array.from(new Set(_notes.map(note=>note.id))).map(id=>{
        return _notes.find(note => note.id === id)
      })
      _uniqNotes.map((note)=>{
        _out.push({
          start: note.date,
          end: note.date,
          title: 'Заметка',
          allDay: true,
          class: 'note'
        })
      })
      return _out
    }
  },
  mounted() {
    this.$bus.$on('calendarSync', syncStatus => {
      this.calendarSync = syncStatus;
      let _message = syncStatus
        ? 'Синхронизация с календарем включена'
        : 'Синхронизация с календарем выключена';
      this.$dmsSuccessNoty(_message);
    });
    this.$bus.$on('showOnCalendar', date => {
      this.today = date
    })
    this.$bus.$on('expandNotes', status => {
      this.calendarCollapsed = status
    })
  },
  created() {
    let _start = moment().startOf('month').format('YYYY-MM-DD')
    let _end = moment().endOf('month').format('YYYY-MM-DD')
    let _range = {
      start: _start,
      end: _end,
      limit: 31
    }
    store.dispatch('SET_CALENDAR_NOTES', _range)
  },
  destroyed() {
    this.$bus.$off('calendarSync');
    this.$bus.$off('createNote')
    this.$bus.$off('deleteNote')
    this.$bus.$off('showOnCalendar')
    this.$bus.$off('expandNotes')
    this.todayBtn.removeEventListener('click', this.todayBtnHandler);
  }
};
</script>
<style lang='scss'>



</style>


// WEBPACK FOOTER //
// src/apps/bpm/notes/components/CalendarWrapper.vue